var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      ref: "multipleTable",
      staticStyle: { width: "100%" },
      attrs: {
        data: _vm.tableData,
        height: "100%",
        border: true,
        "header-cell-style": { color: "#333333", background: "#EFF6FF" },
        "tooltip-effect": "dark",
      },
      on: { "selection-change": _vm.handleSelectionChange },
    },
    [
      _c("el-table-column", {
        attrs: {
          type: "selection",
          fixed: "left",
          width: "55",
          selectable: _vm.selectAbleFirst,
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "cycle",
          align: "center",
          fixed: "left",
          label: "供货日期",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "head_type_text",
          align: "center",
          label: "责任方",
          fixed: "left",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(" " + _vm._s(scope.row.head_type_text || "-") + " "),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "deduction_amt",
          align: "center",
          label: "扣款金额",
          fixed: "left",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "qc_reason_text",
          align: "center",
          label: "缺货原因",
          fixed: "left",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(" " + _vm._s(scope.row.qc_reason_text || "-") + " "),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "supplier.title",
          align: "center",
          label: "供应商",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(" " + _vm._s(scope.row.supplier.title || "-") + " "),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "buyer.fullname",
          align: "center",
          label: "业务员",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(" " + _vm._s(scope.row.buyer.fullname || "-") + " "),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "store_logistic.name",
          align: "center",
          label: "城市仓",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(_vm._s(scope.row.store_logistic.name || "-")),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "store_delivery.name",
          align: "center",
          label: "自提点",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(_vm._s(scope.row.store_delivery.name || "-")),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "product_snapshot.title",
          align: "center",
          label: "品名",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  " " + _vm._s(scope.row.product_snapshot.title || "-") + " "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "member.fullname",
          align: "center",
          label: "用户姓名",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "member.mobile",
          align: "center",
          label: "用户电话",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "sku_code",
          align: "center",
          label: "货号",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "cate_name",
          align: "center",
          label: "品类",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "supplier_order.supplier_order_no",
          align: "center",
          label: "供货单号",
          "min-width": "100",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "audit_status_text",
          align: "center",
          label: "品控状态",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "qc_user_name",
          align: "center",
          label: "品控员",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(" " + _vm._s(scope.row.qc_user_name || "-") + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "audit_user_name",
          align: "center",
          label: "复核员",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(" " + _vm._s(scope.row.audit_user_name || "-") + " "),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "product_qty",
          align: "center",
          label: "订货数量",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "qc_num",
          align: "center",
          label: "复核数量",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "stock_out_num",
          align: "center",
          label: "缺货数量",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "deduction_time",
          align: "center",
          label: "扣款时间",
          "min-width": "100",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "is_deduct_text",
          align: "center",
          label: "扣款状态",
          "min-width": "100",
          fixed: "right",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "is_coupon_text",
          align: "center",
          label: "发券状态",
          "min-width": "100",
          fixed: "right",
        },
      }),
      _c("el-table-column", {
        attrs: {
          label: "操作",
          "min-width": "120",
          align: "center",
          fixed: "right",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                scope.row.is_deduct === _vm.DEDUCT_STATUS.NO.value
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onHandleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    )
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }